import { render } from "./FlippedNumber.vue?vue&type=template&id=4a814ea6"
import script from "./FlippedNumber.vue?vue&type=script&lang=js"
export * from "./FlippedNumber.vue?vue&type=script&lang=js"

import "./FlippedNumber.vue?vue&type=style&index=0&id=4a814ea6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__